(function(){
var helpers = {
  hasAddonRestaurants: function hasAddonRestaurants(model) {
    return model.Results.AddonsRestaurant &&
      model.Results.AddonsRestaurant.Total;
  },
  displayToMiles: function (miles, unit) {
    var distance = Number(miles);

    if (unit === 'km') {
      distance = miles * 0.621371;
    }

    return Number(distance.toFixed(1));
  },
  milesToDisplay: function (miles, unit) {
    var distance = Number(miles);

    if (unit === 'km') {
      distance = miles * 1.60934;
    }

    return Number(distance.toFixed(1));
  },
  getRelatedSearchLabels: function (searches) {
    function joinSemanticList(list, maxLength) {
      if (list.length === 1) {
        return list[0];
      }

      var shortenedList =
        list.length <= maxLength ?
          list :
          list.slice(0, maxLength);

      var exceptLast = shortenedList.slice(0, shortenedList.length - 1);
      var last = shortenedList[shortenedList.length - 1];

      return exceptLast.join(', ') + ' and ' + last;
    }

    return searches && searches.length ? searches.map(function(searchPair){
      var search = searchPair[1];
      var link = search.link || '#';
      var suggestion = '';
      var MAX_CUISINES = 3;
      var MAX_LOCATIONS = 3;

      if (search) {
        var label = search.label;

        var cuisine = label.cuisinePhrase && label.cuisinePhrase.length ?
          joinSemanticList(label.cuisinePhrase, MAX_CUISINES) + ' in ' : '';

        var location = label.nearestLocationName && label.nearestLocationName.length ?
          joinSemanticList(label.nearestLocationName, MAX_LOCATIONS) : 'a nearby restaurant';

        suggestion = cuisine + location;

        link = '/s/?' + link;
        return [suggestion, link];
      }
    }) : [];
  },
  moment: function hooks() {
        return hookCallback.apply(null, arguments);
    }
};
function toPath(value) {
  if (_(value).isArray()) {
    return value;
  }
  var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g;
  var reEscapeChar = /\\(\\)?/g;
  var result = [];
  value = !value ? '' : value + '';
  value.replace(rePropName, function(match, number, quote, string) {
    result.push(
      quote ? string.replace(reEscapeChar, '$1') : number || match
    );
  });
  return result;
};
function get(object, path) {
  path = toPath(path);
  var pathKey = path + '';

  if (!object) { return; }
  if (pathKey !== undefined && pathKey in object) {
    path = [pathKey];
  }
  var index = 0;
  var length = path.length;

  while (object && index < length) {
    object = object[path[index++]];
  }

  return index && index === length ? object : undefined;
};
function partial(path, options) {
  var locals;

  // parse options
  if (options) {
    // collection
    if (options.collection) {
      delete options.collection;
    } else if ('length' in options) {
      options = {};
    }

    // locals
    if (options.locals) {
      locals = options.locals;
      delete options.locals;
    }
  } else {
    options = {};
  }

  // merge locals into options
  if (locals) {
    options.__proto__ = locals;
  }

  // merge app locals into options
  for (var k in this) {
    if (this.hasOwnProperty(k)) {
      options[k] = options[k] || this[k];
    }
  }

  var translatePathRegex = /\//g;
  var objectPath = path.replace(translatePathRegex, '.');
  var arrayPath = toPath(objectPath);
  var template = get(window.Spark, arrayPath);

  // Try to load the template file
  if (template) {
    return template.RenderView(options);
  }

  template = get(window.Spark, ['Shared'].concat(arrayPath));

  // If that doesn't work, prefix "Shared" and try again
  if (template) {
    return template.RenderView(options);
  }

  var namespacePath = options.namespace.replace(translatePathRegex, '.');
  var namespaceArray = toPath(namespacePath);

  namespaceArray.shift(); // Remove Spark
  namespaceArray.pop();   // Remove template from path, to get folder

  template = get(window.Spark, namespaceArray.concat(arrayPath));

  // If we still don't have a template, chop up the path a bit
  if (template) {
    return template.RenderView(options);
  }

  // Still no template? Fail silently.
  return '<!-- ' + path + '-->';
};
function block(name, html) {
// bound to the blocks object in renderFile
  var blk = this[name];
  if (!blk) {
// always create, so if we request a
// non-existent block we'll get a new one
    blk = this[name] = new Block();
  }
  if (html) {
    blk.append(html);
  }
  return blk;
};
function layout(view){
  this.locals._layoutFile = view;
};
window.Spark = {"Shared":{"Redesign":{"Filters":{"_FilterViewOptions":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var filterViewOptions = locals.filterViewOptions ; buf.push(' ');1; var Resources = !!locals.Resources ? locals.Resources : window.Resources ; buf.push(' ');1; if (filterViewOptions.Display.ShowMapTab) { ; buf.push('<div class="views" id="view_toggle"><div data-view="list" class="icon-as-button ', escape((1,  filterViewOptions.Display.CurrentView === 'list'  ? 'selected' : '' )), '"><svg class="sort-view-toggle-icon" viewBox="0 0 33 29" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="M7.88020833.5 7.88020833 3.5 32.796875 3.5 32.796875.5 7.88020833.5ZM7.88020833 15.8984375 32.796875 15.8984375 32.796875 12.8984375 7.88020833 12.8984375 7.88020833 15.8984375ZM7.88020833 28.3203125 32.796875 28.3203125 32.796875 25.3203125 7.88020833 25.3203125 7.88020833 28.3203125ZM0 4 4 4 4 0 0 0 0 4ZM0 16.421875 4 16.421875 4 12.421875 0 12.421875 0 16.421875ZM0 28.84375 4 28.84375 4 24.84375 0 24.84375 0 28.84375Z" class="svg-list-icon"></path></svg><span class="pref-label">', escape((1,  Resources.Shared.Search.Tabs.List )), '</span></div><div data-view="map" class="icon-for-map icon-as-button ', escape((1,  filterViewOptions.Display.CurrentView === 'map'  ? 'selected' : '' )), '"><svg class="sort-view-toggle-icon" viewBox="0 1 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="M13 3.5 7.4.9l0 0L.9 3.5v15.7l6.5-2.6 5.6 2.5 0 0 6-2.6.1 0V.8L13 3.5zM13.5 17.4V4.7L17.8 3v12.6L13.5 17.4zM12.1 4.4v13l-4.3-1.9v-13L12.1 4.4zM6.5 2.8v12.6L2.2 17V4.4L6.5 2.8z" id="Combined-Shape" class="svg-map-icon"></path></svg><span class="pref-label">', escape((1,  Resources.Shared.Search.Tabs.Map )), '</span></div></div> ');1; } ; buf.push('');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Filters._FilterViewOptions'}
,"_FilterSortOrder":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var request = locals.request ; buf.push(' ');1; var Resources = !!locals.Resources ? locals.Resources : window.Resources ; buf.push(' ');1; var experiments = locals.experiments || {} ; buf.push(' ');1; var showDistance = locals.showDistance ; buf.push(' ');1; var sortingOptions = {
  Distance: Resources.Shared.Redesign.Filters.Label_Sort_Distance,
  Popularity: Resources.Shared.Redesign.Filters.Title_Featured,
  Name: Resources.Shared.Redesign.Filters.Label_Sort_Name,
  Rating: Resources.Shared.Redesign.Filters.Label_Sort_Rating,
  TimeDistance: Resources.Shared.Redesign.Filters.Label_Sort_Distance
} ; buf.push(' ');7; var sortLabel = Resources.Shared.Redesign.Strings.Label_Sort ; buf.push(' ');7; var sortByLabel = Resources.Shared.Redesign.Strings.Label_SortBy ; buf.push(' ');7; var selectedDistance = request.SortString == 'Distance' ; buf.push(' ');7; var selectedPopularity = request.SortString == 'Popularity' ; buf.push(' ');7; var selectedName=request.SortString == 'Name' ; buf.push(' ');7; var selectedRating=request.SortString == 'Rating' ; buf.push(' ');7; var selectedTimeDistance=request.SortString == 'TimeDistance' ; buf.push('<label id="js-sort-dropdown" data-target="sort-filter-menu" class="sort-dropdown"><div class="sort-dropdown__container"> <input type="checkbox" id="js-toggle-sort-menu" class="sort-dropdown__checkbox"><div class="sort-dropdown__button"> ', escape((7,  sortingOptions[request.SortString] || sortingOptions.Popularity )), '</div><ul class="sort-dropdown__options"> ');7; if (showDistance) { ; buf.push('<li class="sort-dropdown__option"> <label for="SortOrder_Distance" class="menu-list-label sort-dropdown__option-label ', escape((7,  selectedDistance ? 'highlight' : '' )), '"><input type="radio" id="SortOrder_Distance" name="SortOrder" class="menu-list-input sort-option sort-dropdown__radio" value="Distance"', escape((7,  selectedDistance ? ' checked' : '' )), '> <span class="sort-dropdown__option-text">', escape((7,  sortingOptions.TimeDistance )), '</span></label></li> ');7; } ; buf.push('<li class="sort-dropdown__option"> <label for="SortOrder_Popular" class="menu-list-label sort-dropdown__option-label ', escape((7,  selectedPopularity ? 'highlight' : '' )), '"><input type="radio" id="SortOrder_Popular" name="SortOrder" class="menu-list-input sort-option sort-dropdown__radio" value="Popularity"', escape((7,  selectedPopularity ? ' checked' : '' )), '> <span class="sort-dropdown__option-text">', escape((7,  sortingOptions.Popularity )), '</span></label></li><li class="sort-dropdown__option"> <label for="SortOrder_Name" class="menu-list-label sort-dropdown__option-label ', escape((7,  selectedName ? 'highlight' : '' )), '"><input type="radio" id="SortOrder_Name" name="SortOrder" class="menu-list-input sort-option sort-dropdown__radio" value="Name"', escape((7,  selectedName ? ' checked' : '' )), '> <span class="sort-dropdown__option-text">', escape((7,  sortingOptions.Name )), '</span></label></li><li class="sort-dropdown__option"> <label for="SortOrder_Rating" class="menu-list-label sort-dropdown__option-label ', escape((7,  selectedRating ? 'highlight' : '' )), '"><input type="radio" id="SortOrder_Rating" name="SortOrder" class="menu-list-input sort-option sort-dropdown__radio" value="Rating"', escape((7,  selectedRating ? ' checked' : '' )), '> <span class="sort-dropdown__option-text">', escape((7,  sortingOptions.Rating )), '</span></label></li></ul></div></label>');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Filters._FilterSortOrder'}
},"Modals":{"_OffersTooltip":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var offersTooltip = locals.offersTooltip ; buf.push(' ');1; var Html = !!locals.Html ? locals.Html : window.Html ; buf.push(' ');1; var Model = locals.Model ; buf.push(' ');1; var PageType = locals.PageType ; buf.push(' ');1; var Request = locals.Request ; buf.push(' ');1; var Resources = !!locals.Resources ? locals.Resources : window.Resources ; buf.push(' ');1; var System = locals.System ; buf.push(' ');1; var block = locals.block ; buf.push(' ');1; var layout = locals.layout ; buf.push(' ');1; var partial = locals.partial ; buf.push('<div class="menu dn menu-opened"><div class="menu-container"><div class="menu-main"><div class="menu-header"> ');1; if (offersTooltip.Offers.length > 1) { ; buf.push(' <strong>', escape((1,  (String.Format(Resources.Shared.Common.Modals.Offers_TooltipHeaderMultiple,offersTooltip.Offers.length)) )), '</strong> ');1; } ; buf.push(' ');1; if (offersTooltip.Offers.length == 1) { ; buf.push(' <strong>', escape((1,  (String.Format(Resources.Shared.Common.Modals.Offers_TooltipHeaderSingle)) )), '</strong> ');1; } ; buf.push('</div><div class="modal-list tooltip-offers"> ');1; offersTooltip.Offers.forEach(function(offer) { ; buf.push(' <label class="offer menu-list-label">', escape((1,  (offer) )), '</label> ');1; }) ; buf.push('</div></div><div class="dn-arrow"></div></div></div>');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Modals._OffersTooltip'}
},"Results":{"_ResultsTitle":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var resultsTitle = locals.resultsTitle;
var Resources = !!locals.Resources ? locals.Resources : window.Resources;
var partial = locals.partial;
var hasAddonRestaurants = locals.helpers.hasAddonRestaurants(resultsTitle);
var showSearchSummary = resultsTitle.Display.OriginalTermFromQuery && resultsTitle.Display.Metro.Name;
var originalQuery = resultsTitle.Display.OriginalTermFromQuery;
; buf.push('<div class="flex-row-justify results-header"> ');7; if (resultsTitle.Experiments.sfx545 && showSearchSummary) { ; buf.push('<div class="results-title-summary-container"><h2 class="results-title-summary"> ', escape((7,  String.Format(Resources.Shared.Redesign.Results.Title_Search_Summary, '"' + originalQuery + '"', resultsTitle.Display.Metro.Name) )), '</h2></div> ');7; } ; buf.push(' ');7; if (hasAddonRestaurants) { ; buf.push('<h3 class="results-title single-search-result"> ', (7,  Resources.Shared.Redesign.Results.RestaurantsYouMayLike ), '</h3> ');7; } else { ; buf.push(' ');7; if (!String.IsNullOrEmpty(resultsTitle.Request.Title)) { ; buf.push('<h2 class="page-title">', escape((7,  resultsTitle.Request.Title )), '</h2> ');7; } ; buf.push('<h3 id="results-title" class="results-title color-dark"> ');7; if (resultsTitle.IsPromo) { ; buf.push(' ');7; if (resultsTitle.Results.Restaurants.length == 1) { ; buf.push(' ');7; var searchTitle=Resources.Shared.Redesign.Results.Title_Promos ; buf.push(' ', escape((7,  String.Format(searchTitle, 1) )), ' <span class="result-promo-title">', escape((7,  resultsTitle.Display.ResultsTitle )), '</span> ');7;} else {; buf.push(' ');7; var searchTitle=Resources.Shared.Redesign.Results.Title_Promos_Plural ; buf.push(' ', escape((7,  String.Format(searchTitle, resultsTitle.Results.Total) )), ' <span class="result-promo-title">', escape((7,  resultsTitle.Display.ResultsTitle )), '</span> ');7; } ; buf.push(' ');7;} else {; buf.push(' ', escape((7,  resultsTitle.Display.ResultsTitle )), ' ');7; } ; buf.push('</h3> ');7; } ; buf.push(' ');7; if (!hasAddonRestaurants || resultsTitle.Display.CurrentView === 'map') { ; buf.push('<div class="sort-view-filters"><div id="sort-filters" class="filter-option right filter-option-sort-orders"> ', (7,  partial('Redesign/Filters/_FilterSortOrder', {
          request: resultsTitle.Request,
          experiments: resultsTitle.Experiments
        }) ), '</div><div class="search-tab right view-toggle"> ', (10,  partial('Redesign/Filters/_FilterViewOptions', {
          filterViewOptions: resultsTitle
        }) ), '</div></div> ');12; } ; buf.push('</div>');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Results._ResultsTitle'}
,"_ConsumerDisclosure":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var Resources = locals.Resources || window.Resources ; buf.push(' ');1; var Request = locals.Request || {} ; buf.push(' ');1; if (locals.SortBy === 'Popularity' && Request.PageType !== 1) { ; buf.push('<div class="content-section-consumer-disclosure"><div class="consumer-disclosure-border"></div> <span class="consumer-disclosure-text">', (1,  Resources.Shared.Redesign.Results.Title_Consumer_Disclosure ), '</span><div class="consumer-disclosure-container"><div id="consumer-disclosure-icon"></div><div id="consumer-disclosure-tooltip"> ', (1,  Resources.Shared.Redesign.Results.Popover_Consumer_Disclosure ), '</div></div></div> ');1; } ; buf.push('');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Results._ConsumerDisclosure'}
,"_TimeslotAvailability":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var timeslotsLeft = locals.timeslotsLeft ; buf.push(' ');1; var experiments = locals.experiments ; buf.push(' ');1; var Resources = locals.Resources || window.Resources ; buf.push(' ');1; if (timeslotsLeft < 5 && timeslotsLeft) { ; buf.push(' ');1; var timeslotString = timeslotsLeft ; buf.push(' ');1; var timeslot = Resources.Shared.Redesign.Strings.TimeslotAvailability_Single ; buf.push(' ');1; var timeslots = String.Format(Resources.Shared.Redesign.Strings.TimeslotAvailability_Multiple, timeslotString) ; buf.push(' ');1; var message = timeslotsLeft === 1 ? timeslot : timeslots ; buf.push('<div class="notice-timeslot"><span class="clock-icon"></span> <span>', (1,  message ), '</span></div> ');1; } ; buf.push('');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Results._TimeslotAvailability'}
,"_Explanation":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var resultViewModel = locals.resultViewModel ; buf.push(' ');1; var restaurant = locals.restaurant ; buf.push(' ');1; if (resultViewModel.Display.showExplanations && restaurant.Explanation) { ; buf.push('<div class="restaurant-explanation"><span class="otkit--thumbs-up-icon--red"></span> ', escape((1,  restaurant.Explanation )), '</div> ');1; } ; buf.push('');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Results._Explanation'}
,"_PopularDishes":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var experiments = locals.experiments ; buf.push(' ');1; var popularDishes = locals.popularDishes ; buf.push(' ');1; var profileUri = locals.profileUri ; buf.push(' ');1; var Resources = locals.Resources || window.Resources ; buf.push(' ');1; var showPopularDishes = experiments.sfx616 >= 1 && popularDishes && popularDishes.length >= 3; ; buf.push(' ');1; if (showPopularDishes) { ; buf.push(' ');1;
    var stringTemplate;

    if (experiments.sfx616 == 1) {
      stringTemplate = Resources.Shared.Redesign.Results.DinerRecommendations_diners_recommend;
    }
    else if (experiments.sfx616 == 2) {
      stringTemplate = Resources.Shared.Redesign.Results.DinerRecommendations_diners_talking;
    }
    else if (experiments.sfx616 == 3) {
      stringTemplate = Resources.Shared.Redesign.Results.DinerRecommendations_diners_talking_and_more;
    }
  ; buf.push(' ');13; var dinerRecommendations = popularDishes.slice(0, 3); ; buf.push('<div class=\'popular-dishes\'><span class=\'menu-book-icon\'></span> <span>', (13,  String.Format(stringTemplate, dinerRecommendations[0], dinerRecommendations[1], dinerRecommendations[2]) ), '</span></div> ');13; } ; buf.push('');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Results._PopularDishes'}
,"_RestaurantPromo":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var searchViewModelPromo = locals.searchViewModelPromo ; buf.push(' ');1; var restaurantPromo = locals.restaurantPromo ; buf.push(' ');1; var restaurantViewModelPromo = locals.restaurantViewModelPromo ; buf.push(' ');1; var Resources = locals.Resources || window.Resources ; buf.push('<div class="rest-row-promo-wrapper"> ');1; if (!String.IsNullOrEmpty(restaurantPromo.Message)) { ; buf.push(' ');1; if (locals.Model.Promo.IsRestaurantWeek) { ; buf.push('<p>', escape((1,  Resources.Shared.Redesign.Strings.Label_TopOffer )), '</p> ');1; } ; buf.push('<div class="rest-promo-message"> ', (1,  (restaurantPromo.Message) ), '</div> ');1; } ; buf.push('</div>');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Results._RestaurantPromo'}
,"_SingleSearchReserveLink":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var searchViewModel = locals.searchViewModel ; buf.push(' ');1; var restaurantViewModel = locals.restaurantViewModel ; buf.push(' ');1; var partial = locals.partial ; buf.push(' ');1; var Resources = locals.Resources || window.Resources ; buf.push(' ');1; if (searchViewModel  &&
    searchViewModel.IsPromo &&
    restaurantViewModel &&
    restaurantViewModel.Promo) { ; buf.push(' ', (4,  partial('Redesign/Results/_RestaurantPromo', {
    searchViewModelPromo: searchViewModel.Promo,
    restaurantPromo: restaurantViewModel.Promo,
    restaurantViewModelPromo: restaurantViewModel
  }) ), ' ');8;} else if (!searchViewModel.Request.IsAvailabilityRequest) { ; buf.push('<div class="rest-row-reserve-button"> <a class="reserve-link button medium" data-profile-url="', escape((8,  (restaurantViewModel.ProfileUri) )), '">', escape((8,  (Resources.Shared.Redesign.Strings.Reserve_Now) )), '</a></div> ');8; } ; buf.push('');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Results._SingleSearchReserveLink'}
,"_Timeslots":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var timeslots = locals.timeslots ; buf.push(' ');1; var timeSlotsRequest = locals.timeSlotsRequest ; buf.push(' ');1; var displayOnlyPopTimes = locals.displayOnlyPopTimes ; buf.push(' ');1; var Model = locals.Model ; buf.push(' ');1; var experiments = Model.Experiments.enums ; buf.push(' ');1; var OnlyExactDateTime = Model.Request.OnlyExactDateTime ; buf.push(' ');1; var Resources = !!locals.Resources ? locals.Resources : window.Resources ; buf.push(' ');1; var showPopTimes = locals.showPopTimes ; buf.push(' ');1; var partial = locals.partial ; buf.push(' ');1; var isPopTableResult = locals.isPopTableResult ; buf.push(' ');1; var timeslotsLeft = timeslots.TimeSlots.filter(function(el) {
  return el.IsAvail;}).length; ; buf.push(' ');2; var isMobile = Model.UserAgent.indexOf(/(tablet|touch|Android|Pixel|iPad|iPhone)/g) !== -1 ; buf.push(' ');2; var giftParams = Model.giftParams ; buf.push(' ');2; var timeslotsTableCategories = [] ; buf.push(' ');2; var correlationId = locals.correlationId ; buf.push(' ');2; if (!isPopTableResult) { ; buf.push('<div class="message-alerts"> ');2; if (!OnlyExactDateTime && timeslots.TimeSlotsComplete) { ; buf.push(' ', (2,  partial('Redesign/Results/_TimeslotAvailability', {
        timeslotsLeft: timeslotsLeft,
        Resources: Resources,
        partial: partial,
        experiments: Model.Experiments
      }) ), ' ');7; } ; buf.push(' ', (7,  partial('Redesign/Results/_Explanation', {}) ), ' ');7; if (Model.Experiments.sfx616) { ; buf.push(' ', (7,  partial('Redesign/Results/_PopularDishes', {
        experiments: Model.Experiments,
        popularDishes: timeslots.PopularDishes,
        profileUri: timeslots.ProfileUri,
        Resources: Resources
      }) ), ' ');12; } ; buf.push('</div> ');12; } ; buf.push(' ');12; if (isMobile) {
  timeslots.TimeSlots = timeslots.TimeSlots.slice(0, 5);
}
; buf.push(' ');15; if (timeslots.HasAvail) { ; buf.push(' ');15;
    var showBonusPointsLegend = false;
    var restaurantHasOffers = false;
    var restRowTimesContainerClass = ['rest-row-times-cont'];

    timeslots.TimeSlots.forEach(function (timeSlot) {
      if (timeSlot.IsAvail && timeSlot.OfferIds && timeSlot.OfferIds.length > 0) {
        restaurantHasOffers = true;
      }
    });

    if (restaurantHasOffers) {
      restRowTimesContainerClass.push('has-offers');
    }
  ; buf.push('<div class="', escape((29,  restRowTimesContainerClass.join(' ') )), '"><div class="rest-row-times"><div class="timeslot-window"><ul class="availability-row-container"> ');29; timeslots.TimeSlots.forEach(function(timeSlot, timeSlotIndex) { ; buf.push(' ');29;
              var timeslotDisabled = !timeSlot.IsAvail || (displayOnlyPopTimes && !timeSlot.HasPop);
              var isExact = timeSlotIndex == 2;
              var hash = timeSlot.Hash || '';
              var hasPop = timeSlot.HasPop && showPopTimes;
              var hasOffers = timeSlot.HasOffers;
              var offerIds = hasOffers ? String.Join(',', timeSlot.OfferIds) : '';
              var offersCount = timeSlot.OfferIds.length + (hasPop ? 1 : 0);
              var isPremium = (timeSlot.Price && timeSlot.Price.Amount > 0);
              var isTicketing = timeSlot.TicketExperiences && timeSlot.TicketExperiences.length;

              var hasTableCategories = timeSlot.TableCategories
                && timeSlot.TableCategories.length
                && !(timeSlot.TableCategories.indexOf("default") !== -1
                  && timeSlot.TableCategories.length === 1);

              if (hasTableCategories && timeSlot.TimeString.indexOf('*') === -1 && Model.Experiments.sfx523 !== 2) {
                timeSlot.TimeString += '*';
              }

              var domainCulture = locals.Model.DomainCulture;
              var cultureUrlSegment = domainCulture.addCultureToPath ?  '/' + domainCulture.Culture : '';
              var pointValue = timeSlot.Points || (hasPop ? 1000 : 100);
              var slotTime = timeSlot.DateTime;

              if (typeof moment != "undefined") {
                slotTime = moment(timeSlot.LinkString).format('HH:mm:ss');
              } else {
                if (typeof slotTime === 'string') {
                  slotTime = timeSlot.DateTime.substring(timeSlot.DateTime.indexOf('T')+1);
                }
              }

              var restRefParam = Model.Request.RestRef ? '&restref=' + timeslots.Id : '';
              var refParam = Model.Request.Ref ? '&ref=' + Model.Request.Ref : '';
              var timeslotFormat = '{6}/book/validate?rid={0}&d={2}&p={1}&pt={5}&ss=0&sd={2}&pofids={3}&hash={4}&corrId={7}';

              if (pointValue > 100) {
                timeslotFormat += '&i=1';
              }

              if (isTicketing) {
                timeslotFormat += '&st=Ticketed&tik=' + encodeURIComponent(timeSlot.tik);
              }

              if(timeSlot.SlotAvailabilityToken) {
                timeslotFormat += '&avt=' + timeSlot.SlotAvailabilityToken;
              }

              var slotUrl = String.Format(
                timeslotFormat,
                timeslots.Id,
                timeSlotsRequest.Covers,
                timeSlot.LinkString,
                String.Join(",", timeSlot.OfferIds),
                hash,
                pointValue,
                cultureUrlSegment,
                correlationId
              );

              var timeslotClasses = ['rest-row-times-btn'];

              if (isExact) {
                timeslotClasses.push('exact');
              }

              if (timeslotDisabled || (isPremium && !Model.Display.ShowPremiumAccess)) {
                timeslotClasses.push('unavailable');
              } else {
                timeslotClasses.push('timeslot');
                if (isPremium && Model.Display.ShowPremiumAccess) {
                  timeslotClasses.push('dtp-button-premium');
                }
                if (hasOffers) {
                  timeslotClasses.push('has-offers');
                }
                if (isTicketing) {
                  timeslotClasses.push('is-ticketing');
                }
              }

              var timeslotParentClasses = ['timeslot-option'];

              if (timeSlot.IsAvail) {
                timeslotParentClasses.push('timeslot-control');
              }

              if ((isPremium && Model.Display.ShowPremiumAccess) || hasPop || hasOffers) {
                timeslotParentClasses.push('offer-container');

                if (isPremium && Model.Display.ShowPremiumAccess) {
                  timeslotParentClasses.push('dtp-button-premium-wrapper');
                }
              }

              var giftAmount;
              if (timeSlot.LoyaltyRedemption && giftParams) {
                var restaurantRewards = Model.Results.PointRedemptionRewards[timeslots.CountryCode];
                if (restaurantRewards) {
                  var timeSlotTier = restaurantRewards[timeSlot.LoyaltyRedemption];
                  if (timeSlotTier) {
                    giftAmount = timeSlotTier.Levels[giftParams.giftAmount]
                  }
                }
              }

              var instantEligible = timeSlot.instantEligible;
              var instantUrl = timeSlot.instantUrl;
             ; buf.push('<li class="', escape((138,  timeslotParentClasses.join(' ') )), '"> <a class="', escape((138,  timeslotClasses.join(' ') )), '" ');138; if (timeSlot.LinkString) { ; buf.push(' data-rid="', escape((138,  timeslots.Id )), '" data-name="', escape((138,  timeslots.Name )), '" data-datetime="', escape((138,  timeSlot.LinkString )), '" data-covers="', escape((138,  timeSlotsRequest.Covers )), '" ');138; } ; buf.push(' ');138; if (timeslotDisabled || (isPremium && !Model.Display.ShowPremiumAccess)) { ; buf.push(' data-offers="', escape((138,  offerIds )), '">&nbsp; ');138; } else { ; buf.push(' ');138; if (hasTableCategories) { ; buf.push(' data-href="', escape((138,  slotUrl )), '" data-table-categories="', (138,  timeSlot.TableCategories ), '" data-table-categories-tooltip-title="Table Types" ');138; } else if (isTicketing) { ; buf.push(' onclick="OT.Common.OCModals.show({ componentName: \'ticketing-modal-web\', componentVersion: \'<3.0.0\', props: { tid: ', (138,  timeSlot.TicketExperiences[0].Id ), ', dateTime: ', escape((138,  JSON.stringify(timeSlot.DateTime) )), ', covers: ', (138,  timeSlotsRequest.Covers ), ', url: ', escape((138,  JSON.stringify(slotUrl) )), ' } })" ');138; } else { ; buf.push(' href="', escape((138,  slotUrl )), '" onclick="OT.BestAnalytics.logRestaurantVisit(', escape((138, timeslots.Id)), ', \'', escape((138, timeSlot.LinkString.substr(timeSlot.LinkString.indexOf(' ')+1))), '\')" ');138; } ; buf.push(' ');138; if (hasPop || hasOffers) { ; buf.push(' ');138; var points = String.Format(Resources.Shared.Redesign.Strings.PointsText, pointValue) ; buf.push(' ');138; var offer = Resources.Shared.Redesign.Strings ; buf.push(' ');138; var offerPlural = offersCount > 1 ? offer.TimeslotLegend_Offers : offer.TimeslotLegend_Offer ; buf.push(' data-has-pop="', escape((138,  hasPop )), '" data-offers="', escape((138,  offerIds )), '" ');138; } else if (isPremium && Model.Display.ShowPremiumAccess) { ; buf.push(' data-premium-access-price-amount="', escape((138,  timeSlot.Price.Amount )), '"> ');138; } ; buf.push(' ');138; if (instantEligible && instantUrl) { ; buf.push(' data-instant-eligible="true" data-instant-url="', escape((138,  instantUrl )), '" ');138; } ; buf.push('> ');138; if (isTicketing && !hasTableCategories) { ; buf.push('<span class="ticket-icon"></span> ');138; } ; buf.push(' <span>', escape((138,  timeSlot.TimeString )), '</span> ');138; if (hasTableCategories) { ; buf.push('<div class="js-table-categories-tooltip table-categories-tooltip"><div class="table-categories-tooltip-arrow"></div><div class="table-categories-tooltip-container"><h5 class="upcase-style">', escape((138,  Resources.Shared.Search.TableCategories.TooltipTitle )), '</h5> ');138; timeSlot.TableCategories.forEach(function(category) { ; buf.push(' ');138; tableCategoryName = Resources.Shared.Search.TableCategories.Categories[category.toLowerCase()] ; buf.push(' ');138; if (timeslotsTableCategories.indexOf(tableCategoryName) === -1) { ; buf.push(' ');138; timeslotsTableCategories.push(tableCategoryName) ; buf.push(' ');138; } ; buf.push('<div>', escape((138,  tableCategoryName )), '</div> ');138; }) ; buf.push('</div></div> ');138; } ; buf.push(' ');138; } ; buf.push('</a> ');138; if (giftAmount) { ; buf.push('<div class="with-points timeslot-with-redemption"> ', escape((138,  giftAmount.Name )), '</div> ');138; } else if (hasOffers) { ; buf.push('<div class="with-points"><i class="with-offers">', escape((138,  offersCount )), '</i>', escape((138,  " " + offerPlural )), '</div> ');138; } else if (!Model.Request.RestRef &&
                ((hasPop && displayOnlyPopTimes && !timeslots.HasOffers) ||
                (hasPop && offersCount === 1))) { ; buf.push('<div class="with-points" data-points-text=\'', escape((140,  points )), '\'> ', escape((140,  points )), '</div> ');140; } else if (isPremium && Model.Display.ShowPremiumAccess) { ; buf.push('<div class="with-points dtp-button-premium-label">Premium</div> ');140; } ; buf.push('</li> ');140; }) ; buf.push(' ');140; if(!timeslots.TimeSlotsComplete) { ; buf.push('<li class="timeslot-option timeslot-empty"></li><li class="timeslot-option timeslot-empty"></li> ');140; } ; buf.push('</ul></div></div></div> ');140;} else {; buf.push('<div class="rest-row-times-cont"> ');140; if (timeslots.BlockedDayMsg) { ; buf.push('<p class="not-available-message"> ', (140,  timeslots.BlockedDayMsg ), '</p> ');140; } else { ; buf.push(' <a href="', escape((140,  timeslots.ProfileUri )), '" class="button minimal">', escape((140,  Resources.Shared.Common.Results.NextAvailableButton )), '</a> ');140; if (!String.IsNullOrEmpty(timeslots.UnAvailMsg)) { ; buf.push('<p class="not-available-message"> ', (140,  timeslots.UnAvailMsg ), '</p> ');140; } ; buf.push(' ');140; } ; buf.push('</div> ');140; } ; buf.push(' ');140; if (Model.Experiments.sfx523 && !isPopTableResult && timeslotsTableCategories.length) { ; buf.push('<div id="rest-row-table-categories" class="rest-row-meta"> ', escape((140,  Resources.Shared.Search.TableCategories.DescriptionTitle + ": " )), ' ');140; timeslotsTableCategories.forEach(function(tableCategory, index) { ; buf.push(' ');140; if (index < timeslotsTableCategories.length - 1) { ; buf.push(' ', escape((140,  tableCategory )), ', ');140; } else { ; buf.push(' ', escape((140,  tableCategory )), ' ');140; } ; buf.push(' ');140; }) ; buf.push('</div> ');140; } ; buf.push(' ', (140,  partial('Redesign/Results/_SingleSearchReserveLink', {
  searchViewModel: Model,
  restaurantViewModel: timeslots
}) ), '');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Results._Timeslots'}
,"_Reviews":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var reviews = locals.reviews ; buf.push(' ');1; var url = locals.url ; buf.push(' ');1; var experiments = locals.Experiments ; buf.push(' ');1; var Resources = !!locals.Resources ? locals.Resources : window.Resources ; buf.push(' ');1; var resultViewModel = locals.resultViewModel ; buf.push(' ');1; var resourceResults = Resources.Shared.Redesign.Results ; buf.push(' ');1; var total = reviews.Total ; buf.push(' ');1; var reviewText = String.Format(reviews.Total === 1 ? resourceResults.Reviews : resourceResults.Reviews_Plural, total) ; buf.push(' ');1; var showRatings = reviews && reviews.Total > 0 && reviews.ShowReviews ; buf.push(' ');1; var isPopTableResult = locals.isPopTableResult ; buf.push('<div class="rest-row-review"> ');1; if (showRatings) { ; buf.push(' ');1; var reviewRating = reviews.Rating ; buf.push(' ');1; var reviewCalculatedRating = reviews.CalculatedRating ; buf.push(' ');1; var starTitle = String.Format(reviewRating == 1 ? Resources.Strings.StarRatingText : Resources.Strings.StarRatingText_Plural, reviewRating) ; buf.push(' ');1; var totalStarsFill = (reviewRating *20) -1; buf.push('<div class="star-rating review-container xsmall-medium"> ');1; if(experiments.sfx657 == 1) { ; buf.push(' ');1; if(reviews.CalculatedRatingTerm) { ; buf.push('<div class="star-rating"><div class="star-wrapper small"><div class="all-stars"></div><div class="all-stars filled" style="width: ', escape((1,  totalStarsFill )), '%"></div></div></div><div class="review-rating-text xsmall-bold"> <span>', escape((1,  resourceResults[reviews.CalculatedRatingTerm] )), '</span></div> ');1; } ; buf.push(' ');1; } else { ; buf.push('<div class="review-rating-score review-rating-score__10 xsmall-bold"> <span>', escape((1,  reviewCalculatedRating )), '</span></div> ');1; if(reviews.CalculatedRatingTerm) { ; buf.push('<div class="review-rating-text xsmall-bold"> <span>', escape((1,  resourceResults[reviews.CalculatedRatingTerm] )), '</span></div> ');1; } ; buf.push(' ');1; } ; buf.push(' <a class="review-link" href="', (1,  url ), '" target="_blank"><span class="underline-hover">(', escape((1,  total )), ')</span></a></div> ');1; if (!isPopTableResult && reviews.Recommended && reviews.Recommended.Count) {
      var recommend = reviews.Recommended;
      var percentRecommend = Math.floor(recommend.Yes/recommend.Count * 100) || 0;
      var showRecommended = percentRecommend > 70 || (recommend.Count && recommend.Count >= 10);
      percentRecommend += '%';
      if (showRecommended) { ; buf.push('<span class="recommended-container"><span class="thumbs-up-icon"></span> <span class="recommended-small">', escape((6,  percentRecommend )), '</span> <span class="recommended-text">', escape((6,  String.Format(Resources.Strings.Recommended, percentRecommend) )), '</span></span> ');6; }
    } ; buf.push(' ');7; } else { ; buf.push('<div class="review-container"> ', escape((7,  Resources.Shared.Redesign.Results.ReviewsComingSoon )), '</div> ');7; } ; buf.push('</div>');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Results._Reviews'}
,"_Pricing":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var price = locals.price ; buf.push(' ');1; var Resources = !!locals.Resources ? locals.Resources : window.Resources ; buf.push(' ');1; var experiments = locals.experiments ; buf.push('<div class="rest-row-pricing"> <i class="pricing--the-price">');1; [1,2,3,4].forEach(function(i, iIndex) { ; buf.push(' ');1; if (i <= price) { ; buf.push(' ', escape((1,  Resources.Shared.Redesign.Strings.CurrencySymbol )), ' ');1; } ; buf.push(' ');1; }) ; buf.push('</i> <span class="pricing--not-the-price">');1; [1,2,3,4].forEach(function(i, iIndex) { ; buf.push(' ');1; if (i <= 4 - price) { ; buf.push(' ', escape((1,  Resources.Shared.Redesign.Strings.CurrencySymbol )), ' ');1; } ; buf.push(' ');1; }) ; buf.push('</span></div>');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Results._Pricing'}
,"_FreeTextBlurb":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1;
  var lookup = locals.lookup;
  var freeTextBaseCheck = locals.freeTextBaseCheck;
  var restaurant = locals.restaurant;

  var freeTextBlurb = '';
  if (freeTextBaseCheck) {
    var single = {};
    single[lookup[restaurant.FreeText.SingleRelevanceSource]] = [restaurant.FreeText.SingleRelevance];
    var type = Object.keys(single)[0];
    var freeTextMatch = single[type].toString();
    var addEllipsis = '&hellip;'
    if (type !== 'Menu') {
      // Converts a randomly chopped sentence into one ending in ...
      freeTextMatch = freeTextMatch.trim().replace(/^([.,'’\/!?$%\^&\*;:}=\-_`~ )]*)/gm, '').trim();
      if (freeTextMatch[0] !== freeTextMatch[0].toUpperCase()) {
        freeTextMatch = '&hellip;' + freeTextMatch;
      }
      if (type === 'Description' || !('.!?'.indexOf(freeTextMatch.slice(-1)) !== -1)) {
        freeTextMatch += '&hellip;';
      }
    }
  }
; buf.push('<div class="freetext"><span class="freetext-item"><span class="freetext-icon freetext-', escape((24,  type.toLowerCase() )), '-icon"></span> <span class="freetext-match freetext-match-', escape((24,  type.toLowerCase() )), '"><span class="match">', (24,  freeTextMatch ), '</span></span></span></div>');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Results._FreeTextBlurb'}
,"_TicketingDetails":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; 
var restaurant = locals.restaurant;
var resultViewModel = locals.resultViewModel;
var Resources = locals.Resources;

if(restaurant.HasTicketedExperienceDetails) {
  var hasMultipleExperiences = resultViewModel.Results.TicketedExperiences[restaurant.Id.toString()].length > 1;
  var ticketingDetails = resultViewModel.Results.TicketedExperiences[restaurant.Id.toString()][0];
; buf.push('<div class="rest-row-ticketing-details"> ');9; if(hasMultipleExperiences) { ; buf.push('<h2 class="rest-row-ticketing-details__heading">', escape((9,  Resources.Shared.Common.Results.Ticketing_Multi_Title )), '</h2><p class="rest-row-ticketing-details__description">', escape((9,  Resources.Shared.Common.Results.Ticketing_Multi_Message )), '</p> ');9; } else {
  var pricePerCoverFormatted = ticketingDetails.ticketTypes[0].pricePerCoverFormatted;
; buf.push('<h2 class="rest-row-ticketing-details__heading">', escape((11,  ticketingDetails.title )), '</h2><p class="rest-row-ticketing-details__description">', escape((11,  String.Format(Resources.Shared.Common.Results.Ticketing_Message, pricePerCoverFormatted) )), '</p> <button class="rest-row-ticketing-details__action" onclick="OT.Common.OCModals.show({\n    componentName: \'ticketing-modal-web\',\n    componentVersion: \'<3.0.0\',\n    props: {\n      tid: ', (15,  ticketingDetails.experienceId ), '\n    }\n  })">', escape((17,  Resources.Shared.Common.Results.Ticketing_DetailsAction )), '</button> ');17; } ; buf.push('</div> ');17; } ; buf.push('');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Results._TicketingDetails'}
,"_Result":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var restaurant = locals.restaurant ; buf.push(' ');1; var reviews = locals.restaurant.Reviews ; buf.push(' ');1; var experiments = locals.Experiments || {} ; buf.push(' ');1; var resultViewModel = locals.resultViewModel ; buf.push(' ');1; var onlyPopTimes = locals.onlyPopTimes ; buf.push(' ');1; var showImages = locals.showImages ; buf.push(' ');1; var Request = locals.Request || resultViewModel.Request ; buf.push(' ');1; var partial = locals.partial ; buf.push(' ');1; var restaurantIndex = locals.restaurantIndex ; buf.push(' ');1; var showPop = locals.showPop ; buf.push(' ');1;/* If the results are showing in the yellow box at the top, this is a PopTableResult. */; buf.push(' ');1; var isPopTableResult = locals.isPopTableResult ; buf.push(' ');1; var Resources = locals.Resources || window.Resources ; buf.push(' ');1; var milesToDisplay = locals.helpers.milesToDisplay ; buf.push(' ');1; var listIndex = restaurantIndex + 1 ; buf.push(' ');1; var missingRestImage = "/s/static/images/no-image.png" ; buf.push(' ');1; var dinersChoiceBaseCheck = restaurant.Reviews.Awards && restaurant.Reviews.Awards.length && !isPopTableResult && resultViewModel.Request.PageType === 0 ; buf.push(' ');1; var freeTextBaseCheck = !isPopTableResult && Request && restaurant.FreeText ; buf.push(' ');1; var contextType =  Resources.Shared.Search.FreeTextSearch ; buf.push(' ');1; var NEWLY_ADDED_RESTAURANTS_PAGE = resultViewModel.Request.PageType === 5 ; buf.push(' ');1; var isPromoted = restaurant.IsPromoted && !isPopTableResult ; buf.push(' ');1; var showDistance = locals.showDistance ; buf.push(' ');1; var isMarketed = !locals.ignoreMarketing ; buf.push(' ');1; var showAffiliatedRestaurantsLink = locals.showAffiliatedRestaurantsLink ; buf.push(' ');1; var correlationId = locals.correlationId ; buf.push(' ');1; var campaignIds = locals.Results && locals.Results.CampaignIds ? locals.Results.CampaignIds[restaurant.Id] : undefined ; buf.push(' ');1; var lookup = {
  menu: 'Menu',
  description: 'Description',
  reviews: 'Reviews'
};; buf.push(' ');5; var cuisine = restaurant.Cuisine; ; buf.push(' ');5; var profileUri = restaurant.ProfileUri ; buf.push(' ');5; var restaurantAvailabilityToken = restaurant.RestaurantAvailabilityToken || '' ; buf.push(' ');5; var bodyCssClasses = ["result", "content-section-list-row", "cf"];

  if (resultViewModel.Display.ShowTimeSlotsInResults) {
    bodyCssClasses.push("with-times");
  }
; buf.push(' ');10; var timeslots = resultViewModel.Display.ShowTimeSlotsInResults ? partial('Redesign/Results/_Timeslots', {
  timeslots: restaurant,
  timeSlotsRequest: resultViewModel.Request,
  notAvailableButtonClass: '',
  displayOnlyPopTimes: onlyPopTimes,
  showPopTimes: showPop,
  Model: resultViewModel,
  partial: partial,
  isPopTableResult: isPopTableResult,
  correlationId: correlationId
}) : '' ; buf.push('<div class="', escape((20,  bodyCssClasses.join(' ') )), '" data-id="', escape((20,  restaurantIndex )), '" data-rid="', escape((20,  restaurant.Id )), '" data-is-promoted="', escape((20,  isPromoted )), '" data-is-marketed="', escape((20,  isMarketed )), '" data-offers="', escape((20,  String.Join(',', restaurant.OfferIds) )), '" data-lat="', escape((20,  restaurant.Lat )), '" data-lon="', escape((20,  restaurant.Lon )), '" data-index="', escape((20,  listIndex )), '" data-restaurant-availability-token="', escape((20,  restaurantAvailabilityToken )), '" ', (20,  campaignIds ? 'data-campaignids="' + campaignIds + '"' : '' ), '><div class="rest-row with-image"> ');20; if (showImages) { ; buf.push('<div class="rest-row-image"> <a href="', escape((20,  profileUri )), '" target="_blank" onclick="OT.BestAnalytics.logRestaurantVisit(', escape((20, restaurant.Id)), ')"><img src="', escape((20,  missingRestImage )), '" ');20; var imageSize = 'legacy' ; buf.push(' data-src="//resizer.otstatic.com/v2/profiles/', escape((20,  imageSize )), '/', escape((20,  restaurant.Id )), '.jpg" alt="', escape((20,  String.Format(Resources.Shared.Search.Results.AltTag, restaurant.Name).toLowerCase() )), '" class="lazy rest-image"/></a></div> ');20; } ; buf.push('<div class="rest-row-info"><div class="rest-row-header', escape((20,  isPromoted ? ' flex-row-justify' : '' )), '"> <a href="', escape((20,  profileUri )), '" class="rest-row-name rest-name ', escape((20,  restaurant.IsJustAdded ? 'just-added' : '' )), '" target="_blank" onclick="OT.BestAnalytics.logRestaurantVisit(', escape((20, restaurant.Id)), ')"><span class="rest-row-name-text">', (20,  (freeTextBaseCheck && restaurant.FreeText.Matches && restaurant.FreeText.Matches.Name && restaurant.FreeText.Matches.Name[0]) || restaurant.Name ), '</span> ');20; if (restaurant.IsJustAdded && !NEWLY_ADDED_RESTAURANTS_PAGE) { ; buf.push(' <span class="new-restaurant-tag">', (20,  Resources.Shared.Common.Results.JustAdded_New ), '</span> ');20; } ; buf.push(' ');20; if (dinersChoiceBaseCheck) { ; buf.push('<span class="diners-choice-badge"><span class="trophy-icon"></span> <span class="diners-choice-kind">', escape((20,  restaurant.Reviews.Awards[0].Name )), '</span></span> ');20; } ; buf.push('</a> ');20; if (isPromoted) { ; buf.push(' <span class="promoted-badge">', escape((20,  Resources.Shared.Common.Results.Promoted )), '</span> ');20; } ; buf.push('</div> ');20; if (isPopTableResult) { ; buf.push('<div class="flex-row-justify"> ', (20,  partial('Redesign/Results/_Reviews', {
            Experiments: resultViewModel.Experiments,
            isPopTableResult: isPopTableResult,
            reviews: reviews,
            size: 'small',
            url: profileUri + '#reviews'
            }) ), ' ');26; if (resultViewModel.Display.ShowPrices && isPopTableResult) { ; buf.push(' ', (26,  partial('Redesign/Results/_Pricing', {
              price: restaurant.PriceBand.Id,
              experiments: resultViewModel.Experiments
              }) ), ' ');29; } ; buf.push('</div><div class="rest-row-meta rest-row-meta-grid"> ');29; if (cuisine)  { ; buf.push(' <span class="rest-row-meta--cuisine rest-row-meta-text">', (29,  cuisine ), '</span> ');29; } ; buf.push(' <span class="rest-row-meta--location rest-row-meta-text">', (29,  restaurant.Location ), '</span></div> ');29; } else if (!showDistance) { ; buf.push(' ');29; if (experiments.sfx589 === 1) { ; buf.push('<div class="flex-row-justify"> ', (29,  partial('Redesign/Results/_Reviews', {
              Experiments: resultViewModel.Experiments,
              isPopTableResult: isPopTableResult,
              reviews: reviews,
              size: 'small',
              url: profileUri + '#reviews'
            }) ), '</div><div class="rest-row-meta rest-row-meta-grid flex-row-justify"> ');35; if (cuisine)  { ; buf.push(' <span class="rest-row-meta--cuisine rest-row-meta-text">', (35,  cuisine ), '</span> ');35; } ; buf.push('<span class="rest-row--text-bullet"></span> <span class="rest-row-meta--location rest-row-meta-text">', escape((35,  restaurant.Location )), '</span><span class="rest-row--text-bullet"></span> ');35; if (resultViewModel.Display.ShowPrices) { ; buf.push(' ', (35,  partial('Redesign/Results/_Pricing', {
                price: restaurant.PriceBand.Id,
                experiments: resultViewModel.Experiments
              }) ), ' ');38; } ; buf.push('</div> ');38; } else { ; buf.push('<div class="flex-row-justify"> ', (38,  partial('Redesign/Results/_Reviews', {
              Experiments: resultViewModel.Experiments,
              isPopTableResult: isPopTableResult,
              reviews: reviews,
              size: 'small',
              url: profileUri + '#reviews'
            }) ), ' ');44; if (resultViewModel.Display.ShowPrices) { ; buf.push(' ', (44,  partial('Redesign/Results/_Pricing', {
                price: restaurant.PriceBand.Id,
                experiments: resultViewModel.Experiments
              }) ), ' ');47; } ; buf.push('</div><div class="rest-row-meta rest-row-meta-grid flex-row-justify"> ');47; if (cuisine)  { ; buf.push(' <span class="rest-row-meta--cuisine rest-row-meta-text">', (47,  cuisine ), '</span> ');47; } ; buf.push(' <span class="rest-row-meta--location rest-row-meta-text">', escape((47,  restaurant.Location )), '</span></div> ');47; } ; buf.push(' ');47; } else { ; buf.push('<div', (47,  showDistance ? ' class="rest-row-info--essentials"' : '' ), '> ');47; if (experiments.sfx589 === 1) { ; buf.push('<div class="rest-row-info--group"> ', (47,  partial('Redesign/Results/_Reviews', {
                Experiments: resultViewModel.Experiments,
                isPopTableResult: isPopTableResult,
                reviews: reviews,
                size: 'small',
                url: profileUri + '#reviews'
              }) ), '<div class="rest-row-meta rest-row-meta-grid rest-row--text-row rest-row-meta-grid--type"> ');53; if (cuisine)  { ; buf.push(' <span class="rest-row-meta--cuisine rest-row-meta-text">', (53,  cuisine ), '</span> ');53; } ; buf.push('<span class="rest-row--text-bullet"></span> ');53; if (resultViewModel.Display.ShowPrices && !showDistance) { ; buf.push(' ', (53,  partial('Redesign/Results/_Pricing', {
                    price: restaurant.PriceBand.Id,
                    experiments: resultViewModel.Experiments
                  }) ), ' ');56; } ; buf.push(' <span class="rest-row-meta--location rest-row-meta-text">', escape((56,  restaurant.Location )), '</span><span class="rest-row--text-bullet"></span> ');56; if (resultViewModel.Display.ShowPrices && showDistance) { ; buf.push(' ', (56,  partial('Redesign/Results/_Pricing', {
                    price: restaurant.PriceBand.Id,
                    experiments: resultViewModel.Experiments
                  }) ), ' ');59; } ; buf.push('<span class="rest-row--text-bullet"></span><span class="distance-icon"></span> <span class="rest-row-meta--distance rest-row-meta-text">', escape((59,  milesToDisplay(restaurant.Distance, Resources.Strings.DistanceUnit_Small) )), ' ', escape((59,  Resources.Strings.DistanceUnit_Small )), '</span></div></div> ');59; } else { ; buf.push('<div class="rest-row-info--group"> ', (59,  partial('Redesign/Results/_Reviews', {
                Experiments: resultViewModel.Experiments,
                isPopTableResult: isPopTableResult,
                reviews: reviews,
                size: 'small',
                url: profileUri + '#reviews'
              }) ), '<div class="rest-row-meta rest-row-meta-grid rest-row--text-row rest-row-meta-grid--type"> ');65; if (resultViewModel.Display.ShowPrices && showDistance) { ; buf.push(' ', (65,  partial('Redesign/Results/_Pricing', {
                    price: restaurant.PriceBand.Id,
                    experiments: resultViewModel.Experiments
                  }) ), '<span class="rest-row--text-bullet"></span> ');68; } ; buf.push(' ');68; if (cuisine)  { ; buf.push(' <span class="rest-row-meta--cuisine rest-row-meta-text">', (68,  cuisine ), '</span> ');68; } ; buf.push(' ');68; if (resultViewModel.Display.ShowPrices && !showDistance) { ; buf.push(' ', (68,  partial('Redesign/Results/_Pricing', {
                    price: restaurant.PriceBand.Id,
                    experiments: resultViewModel.Experiments
                  }) ), ' ');71; } ; buf.push('</div></div> ');71; } ; buf.push(' ');71; if (!experiments.sfx589) { ; buf.push('<div class="rest-row-meta rest-row-meta-grid rest-row--text-row rest-row-meta-grid--distance"> <span class="rest-row-meta--location rest-row-meta-text">', escape((71,  restaurant.Location )), '</span><span class="rest-row-meta--distance rest-row-meta-text"><span class="distance-icon"></span> ', escape((71,  milesToDisplay(restaurant.Distance, Resources.Strings.DistanceUnit_Small) )), ' ', escape((71,  Resources.Strings.DistanceUnit_Small )), '</span></div> ');71; } ; buf.push('</div> ');71; } ; buf.push(' ');71; if (restaurant.IsListingsRestaurant) { ; buf.push('<div class="listings-message"> ', escape((71,  Resources.Shared.Redesign.Results.ListingsMessage )), '</div> ');71; } else if (!isPopTableResult) { ; buf.push(' ', (71,  timeslots ), ' ');71; } ; buf.push(' ');71; if (freeTextBaseCheck && lookup[restaurant.FreeText.SingleRelevanceSource]) { ; buf.push(' ', (71,  partial('Redesign/Results/_FreeTextBlurb', {
          freeTextBaseCheck: freeTextBaseCheck,
          lookup: lookup,
          restaurant: restaurant
        }) ), ' ');75; } ; buf.push(' ', (75,  partial('Redesign/Results/_TicketingDetails', {
        restaurant: restaurant,
        resultViewModel: resultViewModel,
        Resources: Resources
      }) ), ' ');79; if (restaurant.TopOffer != null && !(resultViewModel.Promo && resultViewModel.Promo.IsRestaurantWeek)) { ; buf.push('<div class="rest-row-offer', (79,  restaurant.OfferIds.length > 1 ? ' hide-more-offers' : '' ), '" data-id="', escape((79,  (restaurant.TopOffer.Id) )), '"><p class="all-offers"> ', escape((79,  Resources.Shared.Redesign.Strings.Label_TopOffer )), '<div class="top-offer-name offer-name">', escape((79,  restaurant.TopOffer.Name )), '</div> ');79; if (restaurant.OfferIds.length > 1) { ; buf.push('<div class="more-offers"> ');79; restaurant.Offers.forEach(function(el) { ; buf.push(' ');79; if (el.Name !== restaurant.TopOffer.Name) { ; buf.push('<div class="offer-name">', (79,  el.Name ), '</div> ');79; } ; buf.push(' ');79; }) ; buf.push('</div> ');79; } ; buf.push('</p> ');79; if (restaurant.OfferIds.length > 1) { ; buf.push('<p class="rest-row-offer-link"> ', escape((79,  Resources.Shared.Common.Results.SeeAllOffers )), '</p> <a href="', escape((79,  profileUri )), '#special-offers" target="_blank" class="rest-row-offer-link text-arrow-right">', escape((79,  Resources.Shared.Redesign.Strings.LearnMore )), '</a> ');79; } ; buf.push('</div> ');79; } ; buf.push(' ');79; if (showAffiliatedRestaurantsLink && restaurant.HasAffiliateGroup) { ; buf.push('<div class="rest-row-affiliatedlink"> <a href="/s/affiliaterestaurantlist?affiliaterestaurantid=', (79,  restaurant.Id ), '&covers=', (79,  Request.Covers ), '&datetime=', (79,  Request.DateTime ), '">', escape((79,  Resources.Shared.Redesign.Results.ViewAffiliatedRestaurantsLink )), '</a></div> ');79; } ; buf.push('</div></div> ');79; if (isPopTableResult) { ; buf.push(' ', (79,  timeslots ), ' ');79; } ; buf.push('</div>');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Results._Result'}
,"_Pagination":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var pagination = locals.pagination ; buf.push(' ');1; var showPageNumbers = locals.showPageNumbers ; buf.push(' ');1; var Html = !!locals.Html ? locals.Html : window.Html ; buf.push(' ');1; var Model = locals.Model ; buf.push(' ');1; var PageType = locals.PageType ; buf.push(' ');1; var Request = locals.Request ; buf.push(' ');1; var Resources = !!locals.Resources ? locals.Resources : window.Resources ; buf.push(' ');1; var System = locals.System ; buf.push(' ');1; var block = locals.block ; buf.push(' ');1; var layout = locals.layout ; buf.push(' ');1; var partial = locals.partial ; buf.push(' ');1; var previousLink=(pagination.PaginationLinks ==null) ? '#' : (!String.IsNullOrEmpty(pagination.PaginationLinks.Previous)) ? pagination.PaginationLinks.Previous : '' ; buf.push(' ');1; var nextLink=(pagination.PaginationLinks ==null) ? '#' : (!String.IsNullOrEmpty(pagination.PaginationLinks.Next)) ? pagination.PaginationLinks.Next : '' ; buf.push('<div class="pagination-container"><ul id="results-pagination" class="pagination pagination-border"><li class="pagination-li pagination-arrow pagination-arrow-prev pagination-border-arrow-prev"> ');1; if (!String.IsNullOrEmpty(previousLink)) { ; buf.push(' <a href="', escape((1,  (previousLink) )), '" class="pagination-link pagination-prev"><span class="underline-hover">', escape((1,  Resources.Shared.Redesign.Strings.Label_Previous )), '</span></a> ');1;} else {; buf.push(' <span class="pagination-link pagination-prev pagination-unavailable"><span class="underline-hover">', escape((1,  Resources.Shared.Redesign.Strings.Label_Previous )), '</span></span> ');1; } ; buf.push('</li> ');1; if (showPageNumbers && pagination.PaginationIndex.Pages && pagination.PaginationIndex.Pages.length > 0) { ; buf.push(' ');1; pagination.PaginationIndex.Pages.forEach(function(page, pageIndex) { ; buf.push('<li class="pagination-li"> <span class="js-pagination-page ', escape((1,  ( page.From != -1 ? 'pagination-link' : '') )), ' ', escape((1,  ( page.From == -1 ? 'pagination-spacer' : '') )), ' ', escape((1,  ( page.IsCurrent ? 'pagination-current' : '') )), '" data-from="', escape((1,  (page.From) )), '"><span class="underline-hover">', (1,  page.Name ), '</span></span></li> ');1; }) ; buf.push(' ');1; } ; buf.push('<li class="pagination-li pagination-arrow pagination-arrow-next pagination-border-arrow-next"> ');1; if (!String.IsNullOrEmpty(nextLink)) { ; buf.push(' <a href="', escape((1,  (nextLink) )), '" class="pagination-link pagination-next"><span class="underline-hover">', escape((1,  Resources.Shared.Redesign.Strings.Label_Next )), '</span></a> ');1;} else {; buf.push(' <span class="pagination-link pagination-next pagination-unavailable"><span class="underline-hover">', escape((1,  Resources.Shared.Redesign.Strings.Label_Next )), '</span></span> ');1; } ; buf.push('</li></ul></div>');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Results._Pagination'}
,"_AvailabilityLink":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var availabilityLink = locals.availabilityLink ; buf.push(' ');1; var Resources = !!locals.Resources ? locals.Resources : window.Resources ; buf.push(' ');1; if (availabilityLink.Request.IsAvailabilityRequest && availabilityLink.Request.Availability !== 'intersperse') { ; buf.push(' ');1;
    // For personalizer, we don't have a great indicator of when to show the
    // IntersperseAvailability link, so only show it when there may be
    // unavailable results, and hide it when IntersperseAvailability is false
  ; buf.push('<p class="not-shown-message">', escape((5,  Resources.Shared.Redesign.Results.IncludeInterspercedAvailabilityText )), '</p> <a id="availability_link" class="text-arrow-right with-availability"><span class="underline-hover">', escape((5,  Resources.Shared.Redesign.Results.IncludeInterspercedAvailabilityLink )), '</span></a> ');5; } ; buf.push('');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Results._AvailabilityLink'}
,"_NoResultsFreeText":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var noResults = locals.noResults ; buf.push(' <span class="freetext-noresults-term">', escape((1,  noResults.Request.Term )), '</span>');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Results._NoResultsFreeText'}
,"_NoResults":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1;
var noResults = locals.noResults;
var clearLastFilter = locals.clearLastFilter;
var Request = locals.Request;
var Resources = !!locals.Resources ? locals.Resources : window.Resources;
var System = locals.System;
var block = locals.block;
var layout = locals.layout;
var partial = locals.partial;
var metro = noResults.Display.Metro;
var isFreeTextSearch = noResults.Request.Term;
var metroName = noResults.Display.Metro.Name || ''; // to prevent printing 'null' when no metroid is provided
; buf.push('<div class="content-section-header no-results"> ');13; if (noResults.Display.ShowDescriptionForZeroResults && !String.IsNullOrEmpty(noResults.Display.PageMetaData.Description)) { ; buf.push('<p id="page-description" class="page-description"> ', (13,  noResults.Display.PageMetaData.Description ), '</p> ');13; } ; buf.push('<h3 class="color-dark"> ', escape((13,  Resources.Shared.Redesign.NoResults.Heading )), '</h3><div class="block"><p class="no-result-message"> ');13; if (isFreeTextSearch) { ; buf.push(' ', (13, 
        String.Format(
          Resources.Shared.Search.FreeTextSearch.NoResultsMessage,
          partial('Redesign/Results/_NoResultsFreeText', { })
        )
        ), ' ');18; } ; buf.push(' ');18; if (!noResults.Results.Restaurants.length && !isFreeTextSearch) { ; buf.push(' ', escape((18,  Resources.Shared.Search.Strings.NoSearchResults_NoMatch_Message )), ' ');18; } else { ; buf.push(' ', escape((18,  Resources.Shared.Search.Strings.NoSearchResults_NoMatch_Message_Freetext )), ' ');18; } ; buf.push('</p> ');18; if (clearLastFilter) { ; buf.push(' <button id="clear_last_filter" class="button"> ', escape((18,  Resources.Shared.Search.Strings.NoSearchResults_UndoLastFilterButton )), '</button> ');18; if (!noResults.Results.Restaurants.length) { ; buf.push(' <span class="or">', escape((18,  Resources.Shared.Search.Strings.NoSearchResults_Or )), '</span> ');18; } ; buf.push(' ');18; } ; buf.push(' ');18; if (!noResults.Results.Restaurants.length || isFreeTextSearch) { ; buf.push(' <button id="start_over" class="button"> ', escape((18,  Resources.Shared.Search.Strings.NoSearchResults_StartOverButton )), '</button> ');18; } ; buf.push('</div> ');18; if (!noResults.Results.Restaurants.length) { ; buf.push('<h3 class="color-dark"> ', escape((18,  Resources.Shared.Redesign.NoResults.OtherSuggestionsHeading )), '</h3><div class="block"><div> <a href="', escape((18,  !isNaN(parseInt(noResults.Request.MetroId)) ? '/s/restaurantlist?metroid=' + noResults.Request.MetroId : '/' )), '" class="link no-results-browse-link">', escape((18,  !isNaN(parseInt(noResults.Request.MetroId)) ? String.Format(Resources.Shared.Search.Strings.NoSearchResults_MetroListLink, metroName) : '' )), '</a></div><div> <a href="', escape((18,  !isNaN(parseInt(noResults.Request.MetroId)) ? '/start/?m=' + noResults.Request.MetroId : '/' )), '" class="link">', escape((18,  String.Format(Resources.Shared.Search.Strings.NoSearchResults_MetroLink, metroName) )), '</a></div><p class="no-result-message italic"> ', escape((18,  Resources.Shared.Redesign.NoResults.OtherSuggestionsMessage )), '</p></div> ');18; } ; buf.push('</div>');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Results._NoResults'}
,"_PopTable":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var popTable = locals.popTable ; buf.push(' ');1; var Resources = !!locals.Resources ? locals.Resources : window.Resources ; buf.push(' ');1; var block = locals.block ; buf.push(' ');1; var partial = locals.partial ; buf.push(' ');1; var experiments = popTable.Experiments ; buf.push(' ');1; var aboutPopURL = 'https://help.opentable.com/s/topic/0TO0c000000c8AIGAY/dining-rewards-points' 
; buf.push(' ');1; var popTableSelector = 'poptable-results' ; buf.push(' ');1; var totalPop = popTable.Results.TotalPopAvailable ; buf.push(' ');1; if (popTable.Results.FeaturedPopRestaurants.length > 0 && (popTable.Request.OnlyPopTimes == null || popTable.Request.OnlyPopTimes == false) && (popTable.Request.OnlyUnavailable != true)) { ; buf.push('<section id="', escape((1,  popTableSelector )), '" class="', escape((1,  popTableSelector )), ' content-block with-margin"><div class="content-block-header with-border"><div class="pop-header-block"><h6 class="pop-title"> ', escape((1,  Resources.Shared.Common.Results.FeaturedPointsTitle )), '</h6> <a href="', (1,  aboutPopURL ), '" class="pop-about-link" target="_blank">', escape((1,  Resources.Shared.Redesign.Results.AboutBonusPointRestaurants )), '</a></div></div><div class="pop-result-grid analytics-results-list" data-correlationid="', escape((1,  popTable.Display.PopCorrelationId )), '"> ');1; popTable.Results.FeaturedPopRestaurants.forEach(function(restaurant, restaurantIndex) { ; buf.push(' ', (1,  partial('Redesign/Results/_Result', {
          Experiments: experiments,
          restaurant: restaurant,
          resultViewModel: popTable,
          onlyPopTimes: true,
          showImages: false,
          restaurantIndex: restaurantIndex,
          showPop: popTable.Display.ShowPop,
          isPopTableResult: true,
          correlationId: popTable.Display.PopCorrelationId,
          ignoreMarketing: false,
        }) ), ' ');12; }) ; buf.push('</div> ');12; if (popTable.Results.TotalPopAvailable > popTable.Results.FeaturedPopRestaurants.length) { ; buf.push('<div class="content-block-footer"> <a id="pop_see_all_link" class="text-arrow-right"><span class="underline-hover">', escape((12,  String.Format(Resources.Shared.Common.Results.SeeAllPopRestaurants, popTable.Results.TotalPopAvailable) )), '</span></a></div> ');12; } ; buf.push('</section> ');12; } ; buf.push('');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Results._PopTable'}
,"_LoadingPlaceholder":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('<div class="loading-restaurant"><div class="animated-background"><div class="background-masker header-top"></div><div class="background-masker header-left"></div><div class="background-masker header-right"></div><div class="background-masker header-bottom"></div><div class="background-masker subheader-left"></div><div class="background-masker subheader-right"></div><div class="background-masker subheader-bottom"></div><div class="background-masker subheader-second-left"></div><div class="background-masker subheader-second-right"></div><div class="background-masker subheader-second-bottom"></div><div class="background-masker timeslots-left"></div><div class="background-masker timeslots-bottom"></div></div></div>');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Results._LoadingPlaceholder'}
,"_ResultsTable":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var resultsTable = locals.resultsTable ; buf.push(' ');1; var experiments = resultsTable.Experiments || {} ; buf.push(' ');1; var partial = locals.partial ; buf.push(' ');1; var Resources = locals.Resources || window.Resources ; buf.push(' ');1; var PageType = locals.PageType ; buf.push(' ');1; var Html = locals.Html ; buf.push(' ');1; var queryParams = locals.queryParams ; buf.push(' ');1; var showDistance = resultsTable.Request.IsGeoDistanceRequest ; buf.push(' ');1; if (locals.helpers.hasAddonRestaurants(resultsTable)) { ; buf.push(' ');1; var singleSearchedRestaurant = resultsTable.Results.AddonsRestaurant.Restaurants[0] ; buf.push('<div class="content-section-header"><div class="flex-row-justify exact-header"><h3 class="results-title color-dark single-search-result"> ');1; var searchTerm = resultsTable.Request.Term || singleSearchedRestaurant.Name; ; buf.push(' ', (1,  String.Format(Resources.Shared.Redesign.Results.SingleSearchResults, '"' + searchTerm + '"') ), '</h3><div class="sort-view-filters"><div id="sort-filters" class="filter-option filter-option-sort-orders"> ', (1,  partial('Redesign/Filters/_FilterSortOrder', {
            request: resultsTable.Request,
            experiments: resultsTable.Experiments,
            showDistance: showDistance
          }) ), '</div> ');5; if (!resultsTable.Request.Term) { ; buf.push('<div class="search-tab view-toggle"> ', (5,  partial('Redesign/Filters/_FilterViewOptions', {
              filterViewOptions: resultsTable
            }) ), '</div> ');7; } ; buf.push('</div></div></div><div class="content-section-list infinite-results-list exact-match analytics-results-list" data-correlationid="', escape((7,  resultsTable.Display.RestaurantResultsCorrelationId )), '"><div class="exact-title"> ');7; var recommend = singleSearchedRestaurant.Reviews.Recommended;
         var percentRecommend = !!recommend ? Math.floor(recommend.Yes/recommend.Count * 100) : 0; ; buf.push(' ');8; if (percentRecommend >= 75) { ; buf.push(' ', escape((8,  String.Format(Resources.Strings.ExactMatch_Recommend, percentRecommend) )), ' ');8; } else { ; buf.push(' ', escape((8,  Resources.Strings.ExactMatch_Urgency )), ' ');8; } ; buf.push('</div> ');8; resultsTable.Results.AddonsRestaurant.Restaurants.forEach(function(restaurant, restaurantIndex) { ; buf.push(' ', (8,  partial('Redesign/Results/_Result', {
          Experiments: resultsTable.Experiments,
          restaurant: restaurant,
          resultViewModel: resultsTable,
          onlyPopTimes: !!resultsTable.Request.OnlyPopTimes,
          showImages: true,
          restaurantIndex: restaurantIndex,
          showPop: resultsTable.Display.ShowPop,
          isPopTableResult: false,
          showDistance: showDistance,
          ignoreMarketing: true,
          showAffiliatedRestaurantsLink: experiments.sfx348,
          correlationId: resultsTable.Display.RestaurantResultsCorrelationId
        }) ), ' ');21; }) ; buf.push('</div> ');21; } ; buf.push('<div class="content-section-header"> ');21; if (!String.IsNullOrEmpty(resultsTable.Display.Description)) { ; buf.push('<div id="page-description" class="page-description"> ', (21,  (resultsTable.Display.Description) ), '</div> ');21; } ; buf.push(' ', (21,  partial('Redesign/Results/_ResultsTitle', {
    resultsTitle: resultsTable,
    helpers: locals.helpers
  }) ), '</div> ');24; if (resultsTable.Display.ShowPop && resultsTable.Results.TotalPop && !resultsTable.Request.Term && !experiments.sfx708) { ; buf.push('<div id="search_results_pop" class="results-set results-table pop-table" data-name="PopTable"> ', (24,  partial('Redesign/Results/_PopTable', {
        popTable: resultsTable
      }) ), '</div> ');26; } ; buf.push(' ');26; if (resultsTable.Results && resultsTable.Results.Restaurants && resultsTable.Results.Restaurants.length > 0) { ; buf.push(' ', (26,  partial('Redesign/Results/_ConsumerDisclosure', {
    Resources: Resources,
    SortBy: resultsTable.Request.Sort
  }) ), '<div class="content-section-list infinite-results-list analytics-results-list" data-correlationid="', escape((29,  resultsTable.Display.RestaurantResultsCorrelationId )), '"> ');29; if (resultsTable.Display.ShowLoadingPlaceholders) { ; buf.push(' ');29; for(var count = 0; count < 30; count++) { ; buf.push(' ', (29,  partial('Redesign/Results/_LoadingPlaceholder') ), ' ');29; } ; buf.push(' ');29; } else { ; buf.push(' ');29; resultsTable.Results.Restaurants.forEach(function(restaurant, restaurantIndex) { ; buf.push(' ', (29,  partial('Redesign/Results/_Result', {
            Experiments: resultsTable.Experiments,
            Request: resultsTable.Request,
            restaurant: restaurant,
            resultViewModel: resultsTable,
            onlyPopTimes: !!resultsTable.Request.OnlyPopTimes,
            showImages: true,
            restaurantIndex: restaurantIndex,
            showPop: resultsTable.Display.ShowPop,
            isPopTableResult: false,
            showDistance: showDistance,
            correlationId: resultsTable.Display.RestaurantResultsCorrelationId,
            ignoreMarketing: resultsTable.Display.ignoreMarketingForImpressionEvents,
          }) ), ' ');42; }) ; buf.push(' ');42; } ; buf.push('</div> ');42; } ; buf.push(' ');42; if (resultsTable.Display.ShowPagination) { ; buf.push(' ', (42,  partial('Redesign/Results/_Pagination', {
    pagination: resultsTable.Display,
    showPageNumbers: true
  }) ), ' ');45; } ; buf.push(' ', (45,  partial('Redesign/Results/_AvailabilityLink', {
  availabilityLink: resultsTable
}) ), ' ');47; if (!String.IsNullOrEmpty(resultsTable.Display.AdditionalDetails)) { ; buf.push('<div class="promo-more-details"> ', (47,  resultsTable.Display.AdditionalDetails ), '</div> ');47; } ; buf.push('<script>\n  //TODO: Integrate this into react component during rewrite.  It toggles the .rest-row-offer-link from\n  // functionally expanding to see all offers, hiding the p.rest-row-offer-link and showing\n  // a.rest-row-offer-link which changes text from "See all specials" to "Learn More >" and links to the\n  // specials section on rest profile. Ticket: https://opentable.atlassian.net/browse/SV-2558\n  $(\'p.rest-row-offer-link\').on(\'click\', function(event) {\n    event.preventDefault();\n    $(this).closest(\'.hide-more-offers\').removeClass(\'hide-more-offers\').addClass(\'show-more-offers\');\n  });\n</script>');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Results._ResultsTable'}
},"Search":{"Map":{"_ResultsList":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var resultsList = locals.resultsList ; buf.push(' ');1; var experiments = resultsList.Experiments || {} ; buf.push(' ');1; var partial = locals.partial ; buf.push('<div id="map_results_list" class="results-list content-section"><ul class="content-section-list infinite-results-list analytics-results-list" data-correlationid="', escape((1,  resultsList.Display.RestaurantResultsCorrelationId )), '"> ');1; resultsList.Results.Restaurants.forEach(function(restaurant, restaurantIndex) { ; buf.push(' ', (1,  partial('Redesign/Results/_Result', {
          Experiments: experiments,
          Request: resultsList.Request,
          restaurant: restaurant,
          resultViewModel: resultsList,
          onlyPopTimes: false,
          showImages: true,
          restaurantIndex: restaurantIndex,
          showPop: resultsList.Display.ShowPop,
          correlationId: resultsList.Display.RestaurantResultsCorrelationId,
          ignoreMarketing: resultsList.Display.ignoreMarketingForImpressionEvents,
        })
      ), ' ');13; }) ; buf.push('</ul></div>');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Search.Map._ResultsList'}
,"_ResultsMap":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var resultsMap = locals.resultsMap ; buf.push(' ');1; var mapHeight = locals.desiredHeight ? 'height: ' + locals.desiredHeight + 'px;' : '' ; buf.push(' ');1; var partial = locals.partial ; buf.push(' ');1; var Resources = locals.Resources || window.Resources ; buf.push('<div class="page-main cf" style="display: ', escape((1,  resultsMap.Request.ShowMap ? 'block' : '' )), '"><div id="map" class="map-container" style="', (1, mapHeight), '"></div><div id="search" class="search-container to-map-view" style="', (1, mapHeight), '"><div class="max-width-wrapper"><div class="page-main-content"><div class="row"><div class="column no-padding"><div class="content-section-header with-border"> ', (1,  partial('Redesign/Results/_ResultsTitle', {
                resultsTitle: resultsMap
              }) ), ' ', (3,  partial('Redesign/Results/_ConsumerDisclosure', {
                Resources: Resources,
                SortBy: resultsMap.Request.Sort
              }) ), '</div><div class="map-results-scroll-container"><div class="with-padding"> ');6; if (resultsMap.Results.Total > 0) { ; buf.push(' ');6; if (resultsMap.Promo != null) { ; buf.push('<div id="single-search-modal-placeholder" class="modal"></div> ');6; } ; buf.push(' ', (6,  partial('_ResultsList', {resultsList: resultsMap}) ), ' ');6; if (resultsMap.Display.ShowPagination) { ; buf.push(' ', (6,  partial('Redesign/Results/_Pagination', {
                      pagination: resultsMap.Display,
                      showPageNumbers: true
                    }) ), ' ');9; } ; buf.push(' ', (9,  partial('Redesign/Results/_AvailabilityLink', {
                  availabilityLink: resultsMap
                  }) ), ' ');11; } else { ; buf.push(' ', (11,  partial('Redesign/Results/_NoResults', {
                    noResults: resultsMap
                  }) ), ' ');13; } ; buf.push('</div> ', (13,  partial('Common/_MapFooter', {Model: resultsMap}) ), '</div></div></div></div></div></div></div>');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Search.Map._ResultsMap'}
,"_MapOc":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var results = locals.mapOc.Results ; buf.push(' ');1; var domainCulture = locals.mapOc.DomainCulture ; buf.push(' ');1; var ocData = locals.mapOc.ocData ; buf.push('<div class="react-map-container"><oc-component class="ot-react-maps-oc" href="', escape((1,  'https://oc-registry.opentable.com/v2/ot-react-maps-oc/5.x.x' +
            '?centerLat=' + encodeURIComponent(results.Lat) +
            '&centerLng=' + encodeURIComponent(results.Long) +
            '&zoomLevel=' + encodeURIComponent(results.Zoom) +
            '&domain=' + encodeURIComponent(domainCulture.domain) +
            '&lang=' + encodeURIComponent(domainCulture.culture) +
            '&anonymousId=' + encodeURIComponent(ocData.anonymousId) +
            '&gpid=' + encodeURIComponent(ocData.gpid) )), '" data-name="ot-react-maps-oc" data-rendered="false"></oc-component></div>');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Search.Map._MapOc'}
}}},"Common":{"_MapFooter":{ 
  RenderView: function (locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace
            });

            localsWithEjsMateMethods.partial = partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var model = locals.Model ; buf.push(' ');1; var Resources = !!locals.Resources ? locals.Resources : window.Resources ; buf.push('<div class="footer-container-short"><div class="footer-base"> <span class="footer-copyright">', (1,  (String.Format(Resources.Shared.Redesign.Strings.CopyrightFormat, new Date().getFullYear())) ), '</span> <a class="footer-base-link" href="/info/privacypolicy.aspx">', escape((1,  (Resources.Shared.Redesign.Strings.MapFooterLink_Privacy) )), '</a> <a class="footer-base-link" href="/info/agreement.aspx">', escape((1,  (Resources.Shared.Redesign.Strings.MapFooterLink_Terms) )), '</a></div></div>');
return buf.join('');
},
   namespace: 'Spark.Shared.Common._MapFooter'}
}}}})();